<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <expurgo-bdgd-data-table :items="items" :loading="loading" @rechargeTable="getExpurgosBdgd" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ExpurgosService from '@/services/ExpurgosService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      ExpurgoBdgdDataTable: () => import('@/components/dados/expurgo-bdgd/ExpurgoBdgdDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      loading: false
    }),

    created() {
      this.refreshData(this.getExpurgosBdgd);
    },

    methods: {
      getExpurgosBdgd() {
        this.loading = true;

        ExpurgosService.index()
          .then((responseData) => {
            this.items = responseData;
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
